import { CommonModule, registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalSearchComponent } from '@app/shared/modals/modal-search/modal-search.component';
import { PipesModule } from '@app/shared/pipes';
import { ThemeModule, themeMrd, themeReceitaDigital } from '@app/theme';
import { environment } from '@env/environment';
import { InViewportModule } from 'ng-in-viewport';
import { NZ_I18N, pt_BR } from 'ng-zorro-antd/i18n';
import { NgxMaskModule } from 'ngx-mask';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { LayoutModule } from './layout/layout.module';
import { ModalAddProductRennovaComponent } from './modals/modal-add-product-rennova/modal-add-product-rennova.component';
import { ModalBuyerDataComponent } from './modals/modal-buyer-data/modal-buyer-data.component';
import { ModalNewPortalDigitalSignaturesComponent } from './modals/modal-new-portal-digital-signatures/modal-new-portal-digital-signatures.component';
import { NgxLoadingModule } from 'ngx-loading';
import { ModalProtocolsLibraryComponent } from './modals/modal-protocols-library/modal-protocols-library.component';

registerLocaleData(pt);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LayoutModule,
    InViewportModule,
    DirectivesModule,
    PipesModule,
    ComponentsModule,
    ThemeModule.forRoot({
      themes: [themeReceitaDigital, themeMrd],
      active: environment.template
    }),
    NgxMaskModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LayoutModule,
    InViewportModule,
    DirectivesModule,
    PipesModule,
    ComponentsModule,
    ThemeModule,
    NgxMaskModule,
    NgxLoadingModule
  ],
  providers: [{ provide: NZ_I18N, useValue: pt_BR }],
  declarations: [
    ModalAddProductRennovaComponent,
    ModalSearchComponent,
    ModalBuyerDataComponent,
    ModalNewPortalDigitalSignaturesComponent,
    ModalProtocolsLibraryComponent
  ]
})
export class SharedModule {}
